import React from 'react';
import InputTypesEnum from '../Enums/InputTypesEnum';
import InputWithClear from './InputComponents/InputWithClear';
import ClientInvoiceService from '../Services/ClientInvoiceService';
import DataTable from './DataTable/DataTableFigma';
import ClientInvoiceItem from '../Domain/ClientInvoiceItem';
import Loading from './loading';
import ErrorMessage from './ErrorMessage';
import OverWindow from './OverWindow';
import ColButton from './ColButton';
import ButtonFooterContainer from './ButtonFooterContainer';

export default class PopupInvoiceSelect extends React.Component {
  static defaultProps = {
    innerClassName: '',
    text: '',
    okButtonText: 'Yes',
    cancelButtonText: 'Cancel',
    okPopupFunction: () => alert('Please, create the okPopupFunction'),
    closePopupFunction: () => alert('Please, create the closePopupFunction'),
    invoices: [],
    allInvoices: [],
    clientId: '',
    allItemsInTheSearchAreSelected: false,
    searchParameters: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      editedItem: {},
      filterField: '',
      allInvoices: [],
    };
    ClientInvoiceItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  componentDidMount() {
    ClientInvoiceService.GetInvoiceList(this.props.clientId)
      .then((result) => {
        const converted = ClientInvoiceService.ConvertDBItem(result);
        this.setState({
          invoices: converted,
          allInvoices: converted,
          loading: false,
          filterField: '',
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('PIS56'));
  }

  renderResults() {
    return (
      <>
        {this.state.loading ? (
          <Loading />
        ) : this.state.invoices ? (
          <DataTable
            itemList={this.state.invoices}
            type={ClientInvoiceItem}
          />
        ) : (
          'No results for this search set.'
        )}
      </>
    );
  }

  handleListItemClickInSource(e, index) {
    const newEditedItem = { ...this.state.editedItem };
    this.setState({ editedItem: newEditedItem });
  }

  changeOfEditedItem(fieldName, newValue) {
    if (fieldName === 'filterField') {
      if (newValue === '') {
        this.setState({ invoices: this.state.allInvoices });
      } else {
        const filteredInvoices = this.state.allInvoices.filter((f) => f.CiId.toString().includes(newValue));
        this.setState({ invoices: filteredInvoices });
      }
    }
  }

  renderInputField(fieldName, labelText, colwidth, type, selectValues) {
    return (
      <div className={colwidth}>
        <InputWithClear
          fieldName={fieldName}
          labelText={labelText}
          type={type}
          value={this.state.editedItem[fieldName]}
          selectValues={selectValues}
          onChange={(fieldName, newValue) => {
            this.changeOfEditedItem(fieldName, newValue);
          }}
        />
      </div>
    );
  }

  renderButtons() {
    const okEnabled = this.state.allInvoices.some((i) => i.Selected);
    return (
      <ButtonFooterContainer>
        <ColButton
          text={this.props.cancelButtonText}
          onClick={this.props.closePopupFunction}
          disabled={this.props.cancelButtonText === ''}
          icon='fa-solid fa-circle-xmark'
        />
        <ColButton
          text={this.props.okButtonText}
          type='submit'
          icon='fa-solid fa-save'
          disabled={this.state.saving || !okEnabled}
        />
      </ButtonFooterContainer>
    );
  }

  handleOnSubmit() {
    if (this.state.invoices.filter((f) => f.Selected).length !== 0) {
      ClientInvoiceService.AddToInvoice({
        InCiId: this.state.invoices.find((f) => f.Selected).CiId,
        AsIds: this.props.selectedAssignments.map((s) => s.AsId),
        AllItemsInTheSearchAreSelected: this.props.allItemsInTheSearchAreSelected,
        SearchParameters: this.props.searchParameters,
      })
        .then((result) => {
          if (result && result.error) {
            ErrorMessage.SetErrorMessage(result.error);
          }
        })
        .catch(() => {
          ErrorMessage.SetErrorMessage('PIS153');
          this.setState({ loading: false });
        });
      ErrorMessage.SetNotification(
        'Started adding assignments to the invoice in the background. You will receive an in-app notification when the process is done.'
      );
      this.props.okPopupFunction(this.state.editedItem);
      return;
    }
    this.props.okPopupFunction(this.state.editedItem);
  }

  render() {
    return (
      <OverWindow
        title={`Invoice Popup`}
        clickOnCancel={this.props.closePopupFunction}
        icon='fa-solid fa-edit'
        minHeight={500}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.handleOnSubmit();
          }}
        >
          {this.renderInputField('filterField', 'Find:', 'col', InputTypesEnum.Text)}
          {this.renderResults()}
          {this.renderButtons()}
        </form>
      </OverWindow>
    );
  }

  clickOnSelect(item, selected) {
    item.Selected = selected;
    const templist = [...this.state.invoices];
    templist.forEach((element) => {
      element.Selected = element.CiId === item.CiId ? selected : false;
    });
    this.setState({
      invoices: templist,
      allItemInTheSearchSetAreSelected: false,
    });
  }
}
